<!--
 * @Author: your name
 * @Date: 2022-01-24 16:41:41
 * @LastEditTime: 2022-01-24 17:59:16
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rightcloud-console\src\views\console\hpc\index.vue
-->
<template>
    <div class="module hpc-container"
         style=" position: relative;">
        <help-info :helpData="helpData" />
        <loading v-if="isLoading"
                 :size='24'
                 style="height:80%" />
        <!-- 开通状态 -->
        <div v-else-if="status===true"
             class="module-container">
            <activate />
        </div>
        <!-- 未开通状态 -->
        <div v-else-if="status===false"
             class="module-container"
             style="background: #f5f6f7;">
            <non-activate />
        </div>
        <div v-else
             class="error-text">
            <img src="@/assets/images/building.png" />
            <p class="info">{{$t('网络波动，暂时无法显示当前信息，请刷新后重试！')}}</p>
        </div>
    </div>
</template>
<script>
import API from '@/service/api.js'
import helpInfo from '@c/basic/helpinfo'
import loading from '@c/basic/loading'
import nonActivate from './components/nonactivate'
import activate from './components/activate'

export default {
    name: 'hpc',
    components: {
        helpInfo,
        loading,
        nonActivate,
        activate
    },
    data () {
        return {
            isLoading: false,
            helpData: {
                modelName: this.$t('高性能计算HPC')
            },
            status: ''
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.isLoading = true
            this.axios.get(this.urlFormat(API.ALL_HPC_EXIST)).then(res => {
                if (res) {
                    this.status = !!res
                } else {
                    this.status = false
                }
                this.isLoading = false
            }).catch(e => {
                this.isLoading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
.error-text {
    width: 100%;
    height: calc(~'100% - 47px');
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    img {
        width: 200px;
    }
    p {
        padding-top: 20px;
    }
}
.info {
    font-size: 14px;
    color: #666;
}
</style>
